import cx from 'classnames'
import { useSearchGroups } from 'components/Wizards/Catalogue/useGroupSearch'
import { useState } from 'react'
import { GroupComboBox } from 'screens/blaze/Home/components/Catalogue/components/GroupComboBox/GroupComboBox'
import Styles from './BrandWizardNewDesignModal.module.scss'
import { Group } from 'components/Wizards/Catalogue/Types'

interface Props {
  initialValues: object
  groups: Group[]
}

export const Search = ({ initialValues, groups }: Props) => {
  const searchGroups = useSearchGroups()
  const [search, setSearch] = useState('')
  const filteredGroups = searchGroups(groups, search || '')
  const [isFocused, setFocused] = useState(false)

  return (
    <div className={cx(Styles.search, { [Styles.focused]: isFocused })}>
      <GroupComboBox
        initialValues={initialValues}
        groups={filteredGroups}
        onInputChange={(value) => setSearch(value)}
        inputValue={search}
        contentsClassName={Styles.searchContents}
        inputClassName={Styles.searchInput}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
    </div>
  )
}
